import {BrowserModule, Title} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CdkTableModule} from '@angular/cdk/table';
import {NgModule, ErrorHandler} from '@angular/core';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';

import { NgxLinkifyjsModule } from 'ngx-linkifyjs';

import {UserService} from './shared/user.service';
import {UserSettingsService} from './shared/user-settings.service';
import {ApiService} from './shared/api.service';
import {AssignmentsService, DeleteErrorDialog, DeleteDialog} from './shared/assignments.service';
import {ImagesService, ImagesErrorhDialog, ImageDeletehDialog, ServerErrorDialog, UploadInProgressDialog} from './shared/images.service';
import {NotificationService} from './shared/notification.service';
import {TeamService} from './shared/team.service';

import {SharedModule} from './shared/shared.module';
import {FieldsModule} from './fields/fields.module';
import {SlideshowModule} from './slideshow/slideshow.module';

import {AppComponent} from './app.component';
import {ColumnsComponent} from './assignments/columns.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {PageNotFoundComponent} from './dashboard/not-found.component';
import {AssignmentsComponent, StatusPipe} from './assignments/assignment-list.component';
import {AssignmentComponent} from './assignments/assignment-create.component';
import {SaveViewComponent, SaveViewDialog} from './assignments/save-view.component';
import {FiltersComponent} from './assignments/filters.component';
import {FiltersService, MatcherPipe, DoNotFilterPipe, OrderByPipe} from './assignments/filters.service';
import {ImportComponent, ErrorDialog, PaginatePipe} from './import/import.component';
import {LoginComponent} from './login/login.component';
import {MenuComponent, KeyValuePipe} from './menu/menu.component';
import {NotificationsComponent} from './notifications/notifications.component';
import {UserCreateComponent} from './users/user-create.component';
import {UsersComponent} from './users/user-list.component';
import {ViewService} from './shared/view.service';

import {AppRoutesModule} from './app.routes.module';
import {RouterGuard} from './router.guard';

import {NoopInterceptor} from './shared/api.interceptor';
import {SwarmErrorHandler, LoginDialog} from './error-handler.component';

@NgModule({
    declarations: [
        AppComponent,
        AssignmentComponent,
        AssignmentsComponent,
        ColumnsComponent,
        DashboardComponent,
        DoNotFilterPipe,
        FiltersComponent,
        ErrorDialog,
        ImageDeletehDialog,
        ImagesErrorhDialog,
        ImportComponent,
        PageNotFoundComponent,
        PaginatePipe,
        LoginComponent,
        MatcherPipe,
        MenuComponent,
        KeyValuePipe,
        NotificationsComponent,
        OrderByPipe,
        UserCreateComponent,
        UsersComponent,
        StatusPipe,
        SaveViewComponent,
        SaveViewDialog,
        ServerErrorDialog,
        UploadInProgressDialog,
        LoginDialog,
        DeleteErrorDialog,
        DeleteDialog
    ],
    entryComponents: [
        ErrorDialog,
        SaveViewDialog,
        ImageDeletehDialog,
        ImagesErrorhDialog,
        ServerErrorDialog,
        UploadInProgressDialog,
        LoginDialog,
        DeleteErrorDialog,
        DeleteDialog
    ],
    imports: [
        AppRoutesModule,
        BrowserModule,
        BrowserAnimationsModule,
        CdkTableModule,
        FieldsModule,
        HttpClientModule,
        NgxLinkifyjsModule.forRoot(),
        SharedModule,
        SlideshowModule.forRoot()
    ],
    providers: [
        ApiService,
        FiltersService,
        UserService,
        UserSettingsService,
        RouterGuard,
        AssignmentsService,
        ImagesService,
        NotificationService,
        TeamService,
        ViewService,
        Title,
        {provide: HTTP_INTERCEPTORS, useClass: NoopInterceptor, multi: true},
        {provide: ErrorHandler, useClass: SwarmErrorHandler}
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/app.module.ts